import circle1 from '../Assets/svg/circle1.svg';
import circle2 from '../Assets/svg/circle2.svg';
import circle3 from '../Assets/svg/circle3.svg';
import circle4 from '../Assets/svg/circle4.svg';
import circle5 from '../Assets/svg/circle5.svg';
import circle6 from '../Assets/svg/circle6.svg';
import circle7 from '../Assets/svg/circle7.svg';
import circle8 from '../Assets/svg/circle8.svg';
import circle9 from '../Assets/svg/circle9.svg';
import circle10 from '../Assets/svg/circle11.svg';
import circle11 from '../Assets/svg/circle11.svg';
import circle12 from '../Assets/svg/circle12.svg';
import circle13 from '../Assets/svg/circle13.svg';
import { IColors } from '../Types/Colors';

export const LoopColors:IColors[] = [
	{
		id: 0,
		src: circle1,
		hex: '#FFFFFF'
	},
	{
		id: 1,
		src: circle2,
		hex: '#FF6F61'
	},
	{
		id: 2,
		src: circle3,
		hex: '#264653'
	},
	{
		id: 3,
		src: circle4,
		hex: '#ECEFF2'
	},
	{
		id: 4,
		src: circle5,
		hex: '#F6BD60'
	},
	{
		id: 5,
		src: circle6,
		hex: '#121B26'
	},
];

export const CoinmuniteeColors:IColors[] = [
	{
		id: 0,
		src: circle7,
		hex: '#E6E7E6'
	},
	{
		id: 1,
		src: circle8,
		hex: '#8B7B67'
	},
	{
		id: 2,
		src: circle9,
		hex: '#A2B1A7'
	},
	{
		id: 3,
		src: circle10,
		hex: '#4F6056'
	},
	{
		id: 4,
		src: circle11,
		hex: '#58A771'
	},
	{
		id: 5,
		src: circle12,
		hex: '#264653'
	},
	{
		id: 6,
		src: circle13,
		hex: '#080909'
	}
];